export function formatedCode(code) {
  return code.length === 12
    ? `${code.substring(0, 4)}-${code.substring(4, 8)}-${code.substring(8, 12)}`
    : code.length === 9
    ? `${code.substring(0, 3)}-${code.substring(3, 6)}-${code.substring(6, 9)}`
    : '-';
}
